import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: '登录',
            component: () => import('./pages/Login.vue')
        },
        {
            path: '/register',
            name: '注册',
            component: () => import('./pages/Register.vue')
        },
        {
            path: '/tools',
            name: '工具',
            component: () => import('./pages/Tools.vue')
        },
        {
            path: '/data',
            name: '数据',
            component: () => import('./pages/Data.vue')
        },
        {
            path: '/pay',
            name: '销售回款',
            component: () => import('./pages/Pay.vue')
        },
        {
            path: '/',
            name: '首页',
            component: () => import('./pages/Index.vue'),
            children: [
                {
                    path: '/dashboard',
                    name: '控制台',
                    component: () => import('./pages/dashboard/Index.vue'),
                    icon: 'anticon anticon-dashboard',
                    children: []
                },
                {
                    path: '/learn',
                    name: '学习成长',
                    component: () => import('./pages/learn/Index.vue'),
                    icon: 'anticon anticon-highlight',
                    children: [
                        {
                            path: '/learn/exercise',
                            name: '练习',
                            component: () => import('./pages/learn/Exercise.vue'),
                            children: []
                        },
                        {
                            path: '/learn/exam',
                            name: '考试',
                            component: () => import('./pages/learn/Exam.vue'),
                            children: []
                        },
                        {
                            path: '/learn/question',
                            name: '题库',
                            component: () => import('./pages/learn/Question.vue'),
                            children: []
                        },
                        {
                            path: '/learn/setting',
                            name: '设置',
                            component: () => import('./pages/learn/Question.vue'),
                            children: []
                        }
                    ]
                },
                {
                    path: '/sale',
                    name: '销售管理',
                    component: () => import('./pages/sale/Index.vue'),
                    icon: 'anticon anticon-whatsapp',
                    children: [
                        {
                            path: '/sale/sea',
                            name: '公海',
                            component: () => import('./pages/sale/Sea.vue'),
                            children: []
                        },
                        {
                            path: '/sale/customer',
                            name: '客户',
                            component: () => import('./pages/sale/Customer.vue'),
                            children: []
                        },
                        {
                            path: '/sale/order',
                            name: '订单',
                            component: () => import('./pages/sale/Order.vue'),
                            children: []
                        },
                        {
                            path: '/sale/follow',
                            name: '跟进',
                            component: () => import('./pages/sale/Follow.vue'),
                            children: []
                        }
                    ]
                },
                {
                    path: '/stock',
                    name: '库存管理',
                    component: () => import('./pages/stock/Index.vue'),
                    icon: 'anticon anticon-table',
                    children: [
                        {
                            path: '/stock/product',
                            name: '商品',
                            component: () => import('./pages/stock/Product.vue'),
                            children: []
                        },
                        {
                            path: '/stock/storage',
                            name: '库房',
                            component: () => import('./pages/stock/Storage.vue'),
                            children: []
                        }
                    ]
                },
                {
                    path: '/cooperation',
                    name: '合作管理',
                    component: () => import('./pages/cooperation/Index.vue'),
                    icon: 'anticon anticon-crown',
                    children: []
                },
                {
                    path: '/activity',
                    name: '活动管理',
                    component: () => import('./pages/activity/Index.vue'),
                    icon: 'anticon anticon-gift',
                    children: [
                        {
                            path: '/activity/raffle',
                            name: '抽奖',
                            component: () => import('./pages/activity/Raffle.vue'),
                            children: []
                        }
                    ]
                },
                {
                    path: '/setting',
                    name: '系统设置',
                    component: () => import('./pages/setting/Index.vue'),
                    icon: 'anticon anticon-setting',
                    children: [
                        {
                            path: '/setting/department',
                            name: '部门',
                            component: () => import('./pages/setting/Department.vue'),
                            children: []
                        },
                        {
                            path: '/setting/staff',
                            name: '成员',
                            component: () => import('./pages/setting/Staff.vue'),
                            children: []
                        },
                        {
                            path: '/setting/sea',
                            name: '公海',
                            component: () => import('./pages/setting/Sea.vue'),
                            children: []
                        },
                        {
                            path: '/setting/system',
                            name: '设置',
                            component: () => import('./pages/setting/System.vue'),
                            children: []
                        }
                    ]
                },
                {
                    path: '/personal',
                    name: '个人中心',
                    component: () => import('./pages/personal/Index.vue')
                },
                {
                    path: '/task',
                    name: '消息提醒',
                    component: () => import('./pages/task/Index.vue'),
                    icon: 'anticon anticon-bell'
                },
                {
                    path: '/exit',
                    name: '退出系统',
                    component: () => import('./pages/exit/Index.vue'),
                    icon: 'anticon anticon-poweroff'
                }
            ]
        }
    ]
})

export default router
